import { system } from 'styled-system';

export const backgroundColor = system({
  backgroundColor: {
    property: 'background',
    scale: 'colors',
  },
});
